module.exports = __webpack_public_path__ + "static/media/7-1.85093efd.mp3";